
import axios from 'axios'

import { authorizationCheck } from './auth.service'
import { CompletionStatus,  Outcome } from './Model/Outcome'


const { NODE_ENV, REACT_APP_EM_API_URL, REACT_APP_PARTICIPANT_PORTAL_URL } = process.env
const MOCK_OUTCOMES_STATUS = {
	completionStatus: CompletionStatus.COMPLETED,
	completionDate: new Date('2008-09-15T15:53:00'),
	dropReason: 'Unknown'
}

// TODO - remove counter when final releasing
let counter = 0

export const getEnrollParticipantUrl = (code: number): string => `${REACT_APP_PARTICIPANT_PORTAL_URL}?code=${code}`

export const getActivityParticipantOutcomeStatusByURL = async (url: string): Promise<Outcome> => {
	if (NODE_ENV !== 'production') {
		counter++
		if(counter % 2 === 0 )  throw Error("Simulate single Outcome fail")

		return await MOCK_OUTCOMES_STATUS
	}

	try {
		const { data } = await axios.get('/outcomes', {
			baseURL: `${REACT_APP_EM_API_URL}${url}`,
		})

		return data
	}catch (e:any) {
		authorizationCheck(e.response.status)
		throw e
	}
}

export const updateActivityParticipantOutcomeStatusByURL = async (
	url: string,
	updatedOutcomes: Outcome
): Promise<Outcome> => {
	if (NODE_ENV !== 'production') {
		return await {...MOCK_OUTCOMES_STATUS, ...updatedOutcomes}
	}

	try {
		const { data } = await axios.patch('/outcomes',updatedOutcomes , {
			baseURL: `${REACT_APP_EM_API_URL}${url}`,
		})

		return data
	}catch (e:any) {
		authorizationCheck(e.response.status)
		return e
	}
}


export const getParticipantData = async (activityId: any) => {
	if (NODE_ENV !== 'production') {
		return [];
	}

	try {
		return await axios.get('/activities/' + activityId + '/participants-data', {
			baseURL: `${REACT_APP_EM_API_URL}`,
		});
	}catch (e:any) {
		authorizationCheck(e.response.status)
		return e
	}
}
